// @oasis-permission-public: Sam decided on 2026-10-23 that every Oasis user can edit Mirage MCP skills
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { ensureSession } from "~/modules/auth/credentials";

export const Route = createFileRoute("/_dash/mcp")({
  component: RouteComponent,
  beforeLoad() {
    ensureSession();
  },
});

function RouteComponent() {
  return <Outlet />;
}
